import React from "react";
import { EVT_KEYDOWN, KEY_L } from "../../../lib";
import { connect } from "react-redux";
import { THEME_HIGH, THEME_LOW, THEME_MEDIUM } from "../../../reducers/reader";
import { setReaderTheme } from "../../../reducers/reader/actions";

import {
    brightnessHighBlack,
    brightnessHighWhite,
    brightnessMediumBlack,
    brightnessMediumWhite,
    brightnessLowBlack,
    brightnessLowWhite,
} from "../../../images";
import { AppState } from "../../../store";

const THEMES = [THEME_HIGH, THEME_MEDIUM, THEME_LOW];

const mapState = ({ reader }: AppState) => ({
    // @ts-ignore
    theme: reader.get("theme") as string,
});
const mapDispatch = {
    setReaderTheme,
};
type StateProps = ReturnType<typeof mapState>;
type DispatchProps = typeof mapDispatch;

type Props = StateProps &
    DispatchProps & {
        isDark: boolean;
    };

class Theme extends React.Component<Props> {
    componentDidMount() {
        window.addEventListener(EVT_KEYDOWN, this.onShortcut);
    }

    componentWillUnmount() {
        window.removeEventListener(EVT_KEYDOWN, this.onShortcut);
    }

    onShortcut = (evt: KeyboardEvent) => {
        if (evt.key.toUpperCase() === KEY_L) {
            this.switchTheme();
        }
    };

    switchTheme = () => {
        let i = THEMES.indexOf(this.props.theme) + 1;
        if (i >= THEMES.length) {
            i = 0;
        }

        this.props.setReaderTheme(THEMES[i]);
    };

    render() {
        const { theme, isDark } = this.props;

        let src;
        if (theme === THEME_HIGH) {
            src = isDark ? brightnessHighWhite : brightnessHighBlack;
        } else if (theme === THEME_MEDIUM) {
            src = isDark ? brightnessMediumWhite : brightnessMediumBlack;
        } else if (theme === THEME_LOW) {
            src = isDark ? brightnessLowWhite : brightnessLowBlack;
        }

        return <img alt="تھیم بدلو" src={src} onClick={this.switchTheme} />;
    }
}

export default connect(mapState, mapDispatch)(Theme);
